import React, { Component } from 'react';
import { Paper, Typography, IconButton, TablePagination } from '@material-ui/core';
import { ArrowDownward } from '@material-ui/icons';
import moment from 'moment';
import * as strings from '../../helpers/strings';
import '../../index.css';
import { connect } from 'react-redux';
import * as deviceFaultReducer from '../reducer';

class SystemDeviceFaultsLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortOrder: { deviceName: 'asc', date: 'asc' }, // Default sort orders
      sortedData: this.expandErrorCodes(this.filterFaultData(this.props.stationDeviceFaultData.deviceFaults || [])), // Default data
      page: 0,
      rowsPerPage: 10, // Default rows per page
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stationDeviceFaultData !== this.props.stationDeviceFaultData) {
      this.setState({
        sortedData: this.expandErrorCodes(this.filterFaultData(this.props.stationDeviceFaultData.deviceFaults || []))
      });
    }
  }

  filterFaultData = (data) => {
    return data.filter(fault => fault.distinctErrorCount > 0);
  }

  expandErrorCodes = (data) => {
    let expandedData = [];
    data.forEach(fault => {
      if (fault.deviceStatus && fault.errorCodes) {
        // Expand statuses and errors for each device independently
        fault.deviceStatus.forEach(status => {
          // Remove the exact phrase "Not Error" and the standalone word "Error"
          const filteredStatus = status.status
            .replace(/\bNot Error\b/g, '')  // Remove the exact phrase "Not Error"
            .replace(/\bError\b/g, '')      // Remove standalone "Error"
            .replace(/\s\s+/g, ' ')         // Replace multiple spaces with a single space
            .trim();                        // Remove leading/trailing spaces
  
          fault.errorCodes.forEach(errorCode => {
            expandedData.push({
              timestamp: fault.faultTm,
              deviceName: fault.deviceName,
              deviceBrand: fault.deviceBrand,
              deviceModel: fault.deviceModel,
              deviceStatus: [{ status: filteredStatus }],  // Use filtered status
              errorCodes: [{ errorCode: errorCode.errorCode }]  // Ensure only one error code per row
            });
          });
        });
      } else {
        // If no deviceStatus or errorCodes, add the fault as is
        expandedData.push(fault);
      }
    });
    return expandedData;
  }    

  // formatDate = (timestamp) => {
  //   const { selectedView } = this.props;
  //   if (selectedView === 'day') {
  //     return moment(timestamp).format('YYYY-MM-DD hh:mm:ss A');
  //   }
  //   return moment(timestamp).format('YYYY-MM-DD');
  // }

  formatDate = (timestamp) => {
    const timestampInMilliseconds = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;
    return moment(timestampInMilliseconds).format('YYYY-MM-DD hh:mm:ss A');
  }

  handleSort = (field) => {
    const { sortedData, sortOrder } = this.state;
    const newSortOrder = sortOrder[field] === 'asc' ? 'desc' : 'asc';
  
    const naturalSort = (a, b) => {
      const extractDeviceNumber = (deviceName) => {
        const match = deviceName.match(/\d+/); // Extract the numeric part of the device name
        return match ? parseInt(match[0], 10) : 0; // If no number, default to 0
      };
  
      if (field === 'deviceName') {
        const deviceNumberA = extractDeviceNumber(a.deviceName);
        const deviceNumberB = extractDeviceNumber(b.deviceName);
  
        if (deviceNumberA < deviceNumberB) return newSortOrder === 'asc' ? -1 : 1;
        if (deviceNumberA > deviceNumberB) return newSortOrder === 'asc' ? 1 : -1;
  
        // If numbers are equal, fall back to string comparison
        if (a.deviceName < b.deviceName) return newSortOrder === 'asc' ? -1 : 1;
        if (a.deviceName > b.deviceName) return newSortOrder === 'asc' ? 1 : -1;
      } else if (field === 'date') {
        if (a.timestamp < b.timestamp) return newSortOrder === 'asc' ? -1 : 1;
        if (a.timestamp > b.timestamp) return newSortOrder === 'asc' ? 1 : -1;
      }
      return 0;
    };
  
    const sorted = [...sortedData].sort(naturalSort);
    this.setState({ sortedData: sorted, sortOrder: { ...sortOrder, [field]: newSortOrder } });
  }  

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
  }

  renderFaultListItem = (fault, counter) => {
    const key = `${fault.timestamp}-${fault.deviceName}-${counter}`; // Ensuring key uniqueness
    return (
      <li className="FaultListBody" key={key}>
        <span className="faultItemNo">{counter}</span>
        <span className="faultItemStation">{this.props.stationName}</span>
        <span className="faultItemDate">{this.formatDate(fault.timestamp)}</span>
        <span className="faultItemDeviceName">{fault.deviceName || 'N/A'}</span>
        <span>{fault.deviceBrand || 'N/A'}</span>
        <span>{fault.deviceModel || 'N/A'}</span>
        <span className="faultItemStatus">
          {fault.deviceStatus && fault.deviceStatus[0]?.status || 'N/A'}
        </span>
        <span className="faultItemError">
          {fault.errorCodes && fault.errorCodes[0]?.errorCode || 'N/A'}
        </span>
      </li>
    );
  }  

  render() {
    const { sortedData, page, rowsPerPage } = this.state;
    const faultsData = sortedData || [];
    const paginatedData = faultsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    let counter = page * rowsPerPage + 1; // Local counter for serial numbers
    // Dynamic style based on data presence
    const faultDetectionStyle = {
      height: faultsData.length > 0 ? '700px' : '200px', // Conditional height
      overflow: 'auto' // Ensures content is scrollable if it overflows
    };
    return (
      <Paper className="SmartOMInfo">
        <Typography className="SmartOMTitle" variant="h6" color="primary">

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
    {/* Empty div to help with centering the label */}
    <div style={{ flex: 1 }}></div>

    <Typography variant="h6" color="primary" style={{ textAlign: 'center', flex: 1 }}>
      {strings.lblSmartOMDetection}
    </Typography>

    {faultsData.length > 5 ? (
      <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={faultsData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
              className="tablePaginationStyle"
            />
      </div>
    ) : (
      <div style={{ flex: 1 }}></div> // Empty div to maintain spacing when pagination is not shown
    )}
  </div>
        
        </Typography>

        {faultsData.length > 0 ? (
          <div className="FaultDetection" style={faultDetectionStyle}>
            <ul className="FaultList">
              <li className="FaultListHeader">
                <span>No</span>
                <span>Station</span>
                <span>
                  Date
                  <IconButton onClick={() => this.handleSort('date')} size="small" className="sortIconStyle">
                    <ArrowDownward fontSize="inherit" />
                  </IconButton>
                </span>
                <span>
                  Device Name
                  <IconButton onClick={() => this.handleSort('deviceName')} size="small" className="sortIconStyle">
                    <ArrowDownward fontSize="inherit" />
                  </IconButton>
                </span>
                <span>Device Brand</span>
                <span>Device Model</span>
                <span>Device Status Fault</span>
                <span>Device Error Fault</span>
              </li>
              {paginatedData.map((fault) => {
                const item = this.renderFaultListItem(fault, counter);
                if (item) counter++; // Only increment if an item is actually rendered
                return item;
              })}
            </ul>
          </div>
        ) : (
          <Typography variant="subtitle1" style={{ margin: '20px' }}>
            No data available. Please submit to see the fault details.
          </Typography>
        )}
      </Paper>
    );
  }
}

const mapStateToProps = (state) => ({
  stationName: state.systemDeviceFaults.selectedStationName,
  stationDeviceFaultData: state.systemDeviceFaults.queryDeviceFaultData,
  selectedView: deviceFaultReducer.getSelectedView(state)
});

export default connect(mapStateToProps)(SystemDeviceFaultsLog);